// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__2WKkx","description":"PatientConsentPreview_description__2IAN3"};